import { Meta, Story } from '@storybook/react';
import { ConditionStep, ConditionStepProps } from './ConditionStep';
export default {
	title: 'Calculators/TravelDeduction/Steps/ConditionStep',
	component: ConditionStep,
} as Meta;

const Template: Story<ConditionStepProps> = (args: ConditionStepProps) => <ConditionStep {...args} />;

export const Default: Story<ConditionStepProps> = Template.bind({});
Default.args = {
	specialAddress: {
		question: 'Bor du i en yderkommune eller på visse små øer?',
		optionsAriaLabel: 'valgmuligheder',
		helpTextHeader: 'Info vedr. små øer og yderkommuner',
		helpText:
			'<p> Du kan få forhøjet kørselsfradrag, hvis du bor i en yderkommune eller på visse små øer, og kører over 120 km om dagen mellem bopæl og arbejde. </p><p> Yderkommuner i Jylland:<br> Brønderslev, Frederikshavn, Hjørring, Jammerbugt, Læsø, Morsø, Norddjurs, Skive, Struer, Sønderborg, Thisted, Tønder, Vesthimmerland, Aabenraa. </p><p> Yderkommuner i Østdanmark og Fyn:<br> Bornholm, Faaborg-Midtfyn, Guldborgsund, Langeland, Lolland, Odsherred, Samsø, Slagelse, Svendborg, Vordingborg, Ærø. </p><p> Små øer:<br> Aarø, Baagø, Egholm, Endelave, Hjarnø, Mandø, Nekselø, Orø, Sejerø, Tunø. </p>',
		options: [
			{ label: 'Ja', value: 'true' },
			{ label: 'Nej', value: 'false', checked: true },
		],
	},
	paymentBridgeUsage: {
		question: 'Kører du over en betalingsbro?',
		optionsAriaLabel: 'valgmuligheder',
		helpTextHeader: 'Brofradrag',
		helpText:
			'<p> Du kan få et ekstra brofradrag, hvis du kører over <!----> Storebæltsbroen eller Øresundsbroen. Bemærk, at ved samkørsel er det kun én i bilen, der kan få det ekstra brofradrag. </p>',
		options: [
			{ label: 'Ja', value: 'true' },
			{ label: 'Nej', value: 'false', checked: true },
		],
	},
	paymentBridges: {
		question: 'Vælg betalingsbro',
		optionsAriaLabel: 'forskellige broer',
		helpTextHeader: 'Betalingsbroer',
		helpText:
			'<table class="table table-bordered table-sm"><tr><td>Bro</td><td>Transportmiddel</td><td style="text-align: right;"> Ekstra fradrag pr. tur i 2021 </td><td style="text-align: right;"> Ekstra fradrag pr. tur i 2022 </td></tr><tr><td><p> Fjordforbindelsen Frederikssund<br>(Kronprinsesse Marys Bro) </p></td><td>Bil</td><td style="text-align: right;">12 kr.</td><td style="text-align: right;">0 kr.</td></tr><tr><td>Storebælt</td><td>Bil/motorcykel</td><td align="right" style="text-align: right;"> 110 kr. </td><td align="right" style="text-align: right;"> 110 kr. </td></tr><tr><td>Storebælt</td><td>Tog/offentlig transport</td><td align="right" style="text-align: right;"> 15 kr. </td><td align="right" style="text-align: right;"> 15 kr. </td></tr><tr><td>Øresund</td><td>Bil/motorcykel</td><td align="right" style="text-align: right;"> 50 kr. </td><td align="right" style="text-align: right;"> 50 kr. </td></tr><tr><td>Øresund</td><td>Tog/offentlig transport</td><td align="right" style="text-align: right;"><p>8 kr.</p></td><td align="right" style="text-align: right;"><p>8 kr.</p></td></tr></table>',
		options: [
			{ label: 'Storebæltsbroen', value: 'greatBeltBridge' },
			{ label: 'Øresundsbroen', value: 'oresundBridge' },
		],
	},
	transportTypes: {
		question: 'Hvilket transportmiddel betaler du for?',
		optionsAriaLabel: 'forskellige transport midler',
		options: [
			{ label: 'Bil', value: 'car' },
			{ label: 'Motorcykel', value: 'motorbike' },
			{ label: 'Tog/Offentlig transport', value: 'publicTransport' },
		],
	},
	paymentBridgeBothWays: {
		question: 'Betaler du begge veje?',
		optionsAriaLabel: 'valgmuligheder',
		options: [
			{ label: 'Ja', value: 'true' },
			{ label: 'Nej', value: 'false' },
		],
	},
};
